import { AnalyticsPageJourneyFilterRestriction } from "../../types/analytics/AnalyticsFilterInputs";
import { FilterAvailableValuesDto } from "../../types/analytics/FilterAvailableValues";
import { apiClient } from "../apiClient";

export interface ActivityWindowDto {
  startDate: string | null;
  endDate: string | null;
}

export interface PointInTimeFloorDto {
  earliestSelectableDate: string | null;
  enabled: boolean;
}

class analyticsFiltersApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  /** Get the filter values available to the logged in user */
  getAvailableFilterValues(
    journeyRestriction: AnalyticsPageJourneyFilterRestriction,
    defaultJourneyFilterPattern: string | undefined | null,
    onSuccess: (data: FilterAvailableValuesDto) => void,
    onError: (error: any) => void
  ) {
    let url =
      "analytics/filters/available-filters?journeyRestriction=" +
      journeyRestriction;
    if (defaultJourneyFilterPattern) {
      url += "&defaultJourneyFilterPattern=" + defaultJourneyFilterPattern;
    }
    return apiClient(this.accessToken, url).then(
      (data) => {
        const filterValues = data as FilterAvailableValuesDto;
        onSuccess(filterValues);
      },
      (error) => {
        onError(error);
      }
    );
  }

  /**
   * Resolve the All-activity absolute window for the selected journey keys (ADR-0003).
   * Returns null start/end when neither JourneyLogs nor AnswerSets have activity.
   */
  resolveActivityWindow(journeyKeys: string[]): Promise<ActivityWindowDto> {
    return apiClient(
      this.accessToken,
      "analytics/filters/resolve-activity-window",
      {
        method: "POST",
        body: JSON.stringify({ journeyKeys }),
      }
    ).then((data) => data as ActivityWindowDto);
  }

  /**
   * Show past data picker floor for the current client (ADR-0006).
   */
  getPointInTimeFloor(): Promise<PointInTimeFloorDto> {
    return apiClient(
      this.accessToken,
      "analytics/filters/point-in-time-floor"
    ).then((data) => data as PointInTimeFloorDto);
  }
}

export default analyticsFiltersApi;
